import { Signer } from "@flixxo/authorizator";
import Axios from "axios";
import { RECAPTCHA_TYPES } from "config/constants";
import { environment } from "config/environment";
import { arch, platform, release, type } from "os";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { GAHandler } from "utils/GA";
import packageInfo from "../../package.json";
import useSession from "./useSession";


const API_URL = environment.apiUrl;
const OSINFO = `${platform()}; ${type()} ${arch()} ${release()}`;
const ENV = environment.name;
const CLIENT =
  `${packageInfo.build.appId}/${packageInfo.version} ` +
  `(${OSINFO}) ${packageInfo.name} (${ENV}) ` +
  `node/${process.versions.node} ` +
  `chrome/${process.versions.chrome} ` +
  `v8/${process.versions.v8} `;


const useApi = () => {

  const { secret, logout } = useSession();
  const { executeRecaptcha } = useGoogleReCaptcha();

  let signer;
  if (secret) signer = new Signer(secret);

  const baseURL = `${API_URL}/api`
  
  const apiFetch = async ({
    url,
    customHeaders = {},
    method = 'get',
    data = {},
    captcha = {}
  }) => {
   
    const ronly = url.replace(/\?[\s\S]*$/g, "");

    
    const lang = localStorage.getItem('i18nextLng')

    let authToken;
    if (secret) authToken = await signer.generateToken(ronly);

    const auth = secret ? {Authorization: `Basic ${btoa(authToken.toString())}`} : {}

    let captchaTokenV3 = ''
    if (captcha.type === RECAPTCHA_TYPES.v3) {
      captchaTokenV3 = await executeRecaptcha(captcha.action);
    }

    return Axios({
      baseURL,
      url,
      method,
      data,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "x-flixxo-client": CLIENT,
        "x-flixxo-lang": lang,
        'x-flixxo-captcha-type': captcha.type,
        'x-flixxo-captcha-token': captchaTokenV3,
        ...auth,
        ...customHeaders
      }
    })
    .catch(res => {

      const { response } = res

      const error = {};

      if (response) {
        error.code = response.status
        error.message = response.data.error.message
        error.name = response.data.error.name
        error.details = response.data.error.details

      } else {
        error.code = ''
        error.message = res.message
        error.name = ''
        error.details = res.stack
      }

      if (error.code === 401) logout?.()

      const newError = {
        code: error.code,
        message: error.message,
        name: error.name,
        details: error.details,
        url,
        version: packageInfo.version
      }

      GAHandler(`res_error`, newError)

      throw newError
    })
  }

  return { apiFetch }
}

export default useApi;
